module.exports = __webpack_public_path__ + "img/client_logo_4.9a4b580a.svg";